import { get } from 'lodash';

export const getFiscalYears = (state) =>
  get(state, 'CommonState.getFiscalYears.fiscalYears');

export const getFiscalYearsError = (state) =>
  get(state, 'CommonState.getFiscalYears.error');

export const getFiscalYearsLoading = (state) =>
  get(state, 'CommonState.getFiscalYears.loading');



// WEBPACK FOOTER //
// ./src/state/fiscalYears/selectors.js